import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function InformacioneTehnologije() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Informacione tehnologije" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Informacione tehnologije</h2>
              <p>
                <strong>Studijski program:</strong> Opšti smjer
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Informacione tehnologije
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 5
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Osnovni cilj predmeta Informacione tehnologije je da se studenti
                studijskog programa Pravo upoznaju sa mogućnostima primjene
                Informacione i komunjikacione tehnologije u pravnoj profesiji.
                Studenti će biti upoznati sa opštim konceptualnim osnovama
                pravne Informatike. Poseban naglasak je na sticanju vještina
                odnosno praktičnih znanja u pronalaženju i korišćenju pravnih
                informacija uz pomoć novih tehnologija baza podataka i
                pretraživača.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Izučavanje ovog predmeta studenti će steći opšta i posebna
                znanja iz područja pravne informatike statistike usmjerene
                analitici u području prava i osnova metodologije društvenih
                istraživanja. Takođe razlikovati različita krivična djela i
                zaštitu iz područja sajber kriminala. Izdvojiti i objasniti
                najvažnija pitanja iz područja upravljanja Internetom i
                regulacije Interneta; Izdvojiti i objasniti pitanja zaštite
                intelektualnog vlasništva u digitalnom okruženju; Takođe
                studenti će biti osposobljeni da na najbolji mogući način
                zaštite pravo na privatnost podataka i opštenja putem interneta
                kao i da daju svoj doprinos budućoj regulaciji i unapređivanju
                ovih oblasti.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                <strong>Teorijska nastava:</strong>
              </p>
              <ul className="values-section">
                <li>
                  Informatička tehnologija i pravo; Značaj pravne informatike;
                  Pronalaženje digitalizovanih pravnih informacija
                </li>
                <li>
                  Primarni izvori prava na internetu; Sekundarni izvori prava na
                  internetu
                </li>
                <li>
                  Područje primjene informacionih tehnologija u pravu; Baze
                  pravnih podataka; Kompjuterizovane službene evidencije; Pravni
                  informacioni sistemi
                </li>
                <li>
                  E-potpis E-uprava i E-trgovina; Izvori informacija za pravnike
                  – E-biblioteke i E-izdavači; Međunarodne institucije iz
                  oblasti prava na internetu
                </li>
                <li>
                  Sajber kriminal; Piraterija; Krivična djela protiv
                  bezbjednosti računarskih podataka; Pravo na privatnost;
                  Zaštita ličnih podataka; Slobodan pristup informacijama
                </li>
              </ul>
              <p>
                <strong>Praktična nastava:</strong>
              </p>
              <ul className="values-section">
                <li>
                  Excel – okruženje osnovne radnje sa ćelijama redovima i
                  kolonama. Primjer: Funkcije pregled svih kategorija. Grafikoni
                  kreiranje i modifikovanje trend. Sortiranje filtriranje
                  međuzbirovi grupisanje podataka uslovno formatizovanje. Pivot
                  tabele. OLAP analiza. Analiza podataka Analiza What – If Goal
                  Seek Solver. Transportni problem rješavanje jednačina.
                </li>
              </ul>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: predavanja i vježbe
                samostalni rad (seminarski rad) i laboratorijske vježbe.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>2P + 2V</td>
                    <td>
                      Osnove informacionih tehnologija; Istorija i osnovna
                      arhitektura računara
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>2P + 2V</td>
                    <td>
                      Informacioni sistemi interni hardver (matična ploča
                      procesor memorije); Eksterni hardver (tastatura miš
                      monitor štampač skener)
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>2P + 2V</td>
                    <td>
                      Informatička tehnologija i pravo; Značaj pravne
                      informatike; Pronalaženje digitalizovanih pravnih
                      informacija
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>2P + 2V</td>
                    <td>
                      Primarni izvori prava na internetu; Sekundarni izvori
                      prava na internetu
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>2P + 2V</td>
                    <td>
                      Područje primjene informacionih tehnologija u pravu; Baze
                      pravnih podataka; Kompjuterizovane službene evidencije;
                      Pravni informacioni sistemi + Praktična nastava. Excel –
                      okruženje osnovne radnje sa ćelijama redovima i kolonama.
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>2P + 2V</td>
                    <td>
                      Funkcije pregled kategorija kreiranje i modifikovanje
                      podataka u računaru kreiranje grafike u računaru
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>2P + 2V</td>
                    <td>
                      Postavljanje i modifikovanje audio-vizuelnih zapisa;
                      Informacioni sistemi softver - sistemski i aplikativni
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>2P + 2V</td>
                    <td>
                      Sortiranje filtriranje međuzbirovi grupisanje podataka
                      uslovno formatizovanje
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>2P + 2V</td>
                    <td>Sistemi za podršku u odlučivanju</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>2P + 2V</td>
                    <td>
                      E-potpis E-uprava i E-trgovina; Izvori informacija za
                      pravnike – E-biblioteke i E-izdavači; Međunarodne
                      institucije iz oblasti prava na internetu + Praktična
                      nastava. Excel – okruženje osnovne radnje sa ćelijama
                      redovima i kolonama. Primjer: Funkcije pregled svih
                      kategorija.
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Kolokvijum II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>2P + 2V</td>
                    <td>
                      Zaštita i sigurnost računskih sistema od virusa i
                      antivirusni programi
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>2P + 2V</td>
                    <td>
                      Sajber kriminal; Piraterija; Krivična djela protiv
                      bezbjednosti računarskih podataka
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>2P + 2V</td>
                    <td>
                      Pravo na privatnost; Zaštita ličnih podataka; Slobodan
                      pristup informacijama + Praktična nastava. Sortiranje
                      filtriranje međuzbirovi grupisanje podataka uslovno
                      formatizovanje. Pivot tabele.
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 4 č / 3h</td>
                            <td>Ukupno: 80 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 2 č / 1.3h</td>
                            <td>Nastava + završni ispit: 60 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 1.3h</td>
                            <td>Priprema i ovjera semestra: 6 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 14 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default InformacioneTehnologije;
